import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Flex, SimpleGrid, Spoiler, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const MoreInfo: React.FC = () => {
  const { t } = useAppTranslation("pages.home.moreInfo");
  const [showSpoiler, toggleSpoiler] = useDisclosure(false);

  const getSection = (label: string, text: string) => (
    <Stack className="px-3" gap={20}>
      <SSHeadline
        props={{
          title: {
            order: 3,
          },
        }}
      >
        <SSWhiteText>{label}</SSWhiteText>
      </SSHeadline>
      <Text
        className="text-justify font-inter font-light"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </Stack>
  );

  return (
    <Flex
      align="start"
      className="w-full w-svw flex-col xs:gap-10 pt-8 text-primary-dark-text md:flex-nowrap md:p-20 lg:flex-row lg:gap-48"
      justify="flex-start"
    >
      <SSHeadline
        props={{ title: { fz: 30 }, stack: { className: "lg:w-1/3" } }}
      >
        <Emoji.Fire />
        <SSLoLGradientText>{t("titlePrefix")}</SSLoLGradientText>
        <SSWhiteText>{t("titleSuffix")}</SSWhiteText>
      </SSHeadline>
      <Stack align="center" justify="center">
        <Spoiler
          className="mb-28 pt-10 lg:pt-0"
          classNames={{
            control: "w-full flex justify-center items-center mt-5",
            root: showSpoiler
              ? ""
              : "relative block " +
                " after:absolute after:bottom-0 after:right-0 after:w-full after:h-[40%] after:z-[1] after:bg-gradient-to-t after:from-primary-background after:from-5% after:to-transparent ",
          }}
          hideLabel={
            <div
              className="default-icon rounded-md px-5 py-2 font-inter"
              onClick={() => toggleSpoiler.close()}
            >
              {t("viewLess")}
            </div>
          }
          maxHeight={500}
          showLabel={
            <div
              className="default-icon rounded-md px-5 py-2 font-inter"
              onClick={() => toggleSpoiler.open()}
            >
              {t("viewMore")}
            </div>
          }
        >
          <SimpleGrid
            className="w-full max-w-[1450px]"
            cols={{ base: 1, xs: 2, md: 3 }}
            spacing="0"
            verticalSpacing="xl"
          >
            {getSection(t("whyUs.title"), t("whyUs.text"))}
            {getSection(t("isSafe.title"), t("isSafe.text"))}
            {getSection(t("whySmurf.title"), t("whySmurf.text"))}
          </SimpleGrid>
        </Spoiler>
      </Stack>
    </Flex>
  );
};

export default MoreInfo;
